<!-- Integrer le top de chaque page -->
<app-header></app-header>
<!-- Integrer le carcase de chaque page --->
<div class="container-fluid page-body-wrapper">
  <app-menu></app-menu>
  <div class="main-panel">
    <div class="content-wrapper">
      <!-- Contenu de la page -->
      <div class="row justify-content-center mt-5">
        <div class="col-md-12 text-center m-5">
          <span class="display-1 font-size-5 d-block text-danger">403</span>
          <div class="mb-4 lead"><h1>{{ 'not-user-title' | translate}}</h1></div>
          <p>{{ 'not-access-explication' | translate}}</p>
          <a  routerLink="/accueil" class="btn btn-fw mt-2 btn-outline-dark">{{ 'not-user-lien' | translate}}</a><br><br>
        </div>
      </div>
      <!-- fin page -->
    </div>
    <!-- Contenu footer -->
    <app-footer></app-footer>
    </div>
  </div>
